import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

export default function PublicRoute({ children }) {
  const isLogin = useAppSelector((state) => state.user.isLogin);

  if (isLogin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

